// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  payment_term_code: yup.string().label("Payment term code").required(),
  payment_term_name: yup.string().label("Payment term name").required()
})